import { useContext } from 'react'
import AuthContext from 'app/contexts/CognitoAuthContext'

const useAuth = () => useContext(AuthContext)

export default useAuth
